import {
	getSourceAppFromUrl,
	getSourceUrlCandidatesFromText,
	isValidSourceUrl,
	MAX_MANAGED_BLOCK_SOURCES,
} from './configuration';
import type { ManagedBlockSource } from './types';

export const getNextSourceEntries = (
	currentEntries: ManagedBlockSource[],
	rawSourceUrls: string,
): {
	entries: ManagedBlockSource[];
	limitExceeded: boolean;
} => {
	const candidates = getSourceUrlCandidatesFromText(rawSourceUrls);
	const seenUrls = new Set(currentEntries.map((source) => source.url));
	const entries = [...currentEntries];
	let limitExceeded = false;

	candidates.forEach((candidate) => {
		if (seenUrls.has(candidate)) {
			return;
		}

		if (entries.length >= MAX_MANAGED_BLOCK_SOURCES) {
			limitExceeded = true;
			return;
		}

		seenUrls.add(candidate);
		entries.push(
			isValidSourceUrl(candidate)
				? {
						app: getSourceAppFromUrl(candidate),
						status: 'resolving',
						url: candidate,
					}
				: {
						invalidReason: 'invalid-url',
						status: 'invalid',
						url: candidate,
					},
		);
	});

	return { entries, limitExceeded };
};

export const replaceSourceEntry = (
	sourceEntries: ManagedBlockSource[],
	url: string,
	update: Omit<ManagedBlockSource, 'url'>,
): ManagedBlockSource[] =>
	sourceEntries.map((source) =>
		source.url === url
			? {
					...source,
					...update,
					url,
				}
			: source,
	);

export const removeSourceEntry = (
	sourceEntries: ManagedBlockSource[],
	sourceUrl: string,
): ManagedBlockSource[] => sourceEntries.filter((source) => source.url !== sourceUrl);
